package com.narbase.letsgo.web.models.linkshare


object ShareLinkParser {

    const val DEFAULT_BASE_URL = "https://share.carapp-africa.net"

    
    const val DEFAULT_HOST = "share.carapp-africa.net"

    
    const val PATH_SEGMENT = "location"

    data class Data(
        val token: String,
        val lat: Double?,
        val lng: Double?,
    )

    fun build(token: String, lat: Double, lng: Double, baseUrl: String = DEFAULT_BASE_URL): String {
        val base = baseUrl.trim().trimEnd('/')
        return "$base/$PATH_SEGMENT/$token?lat=$lat&lng=$lng"
    }

    
    fun parse(url: String): Data? {
        val trimmed = url.trim()
        if (trimmed.isEmpty()) return null

        val hasScheme = "://" in trimmed
        val afterScheme = if (hasScheme) trimmed.substringAfter("://") else trimmed
        val pathPart = afterScheme.substringBefore('?').substringBefore('#')
        val queryPart = afterScheme.substringAfter('?', "").substringBefore('#')

        val segments = pathPart.split('/').filter { it.isNotBlank() }

        // When the url is fully-qualified, its host must be our share host.
        if (hasScheme && segments.firstOrNull() != DEFAULT_HOST) return null

        val segmentIndex = segments.indexOfFirst { it == PATH_SEGMENT }
        if (segmentIndex < 0 || segmentIndex + 1 > segments.lastIndex) return null

        val token = segments[segmentIndex + 1]
        if (token.isBlank()) return null

        val params = parseQuery(queryPart)
        return Data(
            token = token,
            lat = params["lat"]?.toDoubleOrNull(),
            lng = params["lng"]?.toDoubleOrNull(),
        )
    }

    private fun parseQuery(query: String): Map<String, String> {
        if (query.isBlank()) return emptyMap()
        return query.split('&').mapNotNull { pair ->
            val idx = pair.indexOf('=')
            if (idx <= 0) return@mapNotNull null
            pair.substring(0, idx) to pair.substring(idx + 1)
        }.toMap()
    }
}
